// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DateInputWrapper_wrapper__J1VXh {
  position: relative;
  width: 100%;
}

.DateInputWrapper_pickerWrapper__1eYWj {
  position: fixed;
  left: 16px;
  right: 16px;
  background: linear-gradient(160deg, rgba(45, 25, 70, 0.95), rgba(20, 10, 40, 0.95));
  border-radius: 16px;
  padding: 16px;
  z-index: 100;
  box-shadow: 0 -6px 20px rgba(0, 0, 0, 0.7);
  max-width: 470px;
  margin: 0 auto;
}

.DateInputWrapper_pickerWrapper__1eYWj.DateInputWrapper_onboarding__l-who {
  bottom: 20px;
}

.DateInputWrapper_confirmBtn__Urzxg {
  display: flex;
  justify-content: center;
  margin-top: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/components/DateWheelPicker/DateInputWrapper.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,UAAU;EACV,WAAW;EACX,mFAAmF;EACnF,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,0CAA0C;EAC1C,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB","sourcesContent":[".wrapper {\n  position: relative;\n  width: 100%;\n}\n\n.pickerWrapper {\n  position: fixed;\n  left: 16px;\n  right: 16px;\n  background: linear-gradient(160deg, rgba(45, 25, 70, 0.95), rgba(20, 10, 40, 0.95));\n  border-radius: 16px;\n  padding: 16px;\n  z-index: 100;\n  box-shadow: 0 -6px 20px rgba(0, 0, 0, 0.7);\n  max-width: 470px;\n  margin: 0 auto;\n}\n\n.pickerWrapper.onboarding {\n  bottom: 20px;\n}\n\n.confirmBtn {\n  display: flex;\n  justify-content: center;\n  margin-top: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `DateInputWrapper_wrapper__J1VXh`,
	"pickerWrapper": `DateInputWrapper_pickerWrapper__1eYWj`,
	"onboarding": `DateInputWrapper_onboarding__l-who`,
	"confirmBtn": `DateInputWrapper_confirmBtn__Urzxg`
};
export default ___CSS_LOADER_EXPORT___;
